export const Increase = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8987 2.72695L15.1054 2.7311L15.1247 12.9889L25.1556 13.0078L25.1598 15.2145L15.1288 15.1957L15.1474 25.0928L12.9407 25.0886L12.9221 15.1915L2.7981 15.1725L2.79395 12.9657L12.918 12.9848L12.8987 2.72695Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8987 2.72695L15.1054 2.7311L15.1247 12.9889L25.1556 13.0078L25.1598 15.2145L15.1288 15.1957L15.1474 25.0928L12.9407 25.0886L12.9221 15.1915L2.7981 15.1725L2.79395 12.9657L12.918 12.9848L12.8987 2.72695Z"
      fill="currentColor"
    />
  </svg>
);
